<template>
  <div class="d-flex align-center">
    <span
      v-if="withPrepend"
      class="progress-bar__label"
    >
      {{ label || `${value} %` }}
    </span>

    <w-tooltip>
      <template #tooltip-activator="{ on, attrs }">
        <v-progress-linear
          :class="showTooltip ? 'clickable-with-help' : ''"
          :background-color="backgroundColor"
          :color="color"
          :value="value"
          :height="progressBarHeight"
          :rounded="rounded"
          :indeterminate="indeterminate"
          v-on="showTooltip ? on : {}"
        >
          <slot name="default" />
        </v-progress-linear>
      </template>

      <template #tooltip>
        <slot name="tooltip" />
      </template>
    </w-tooltip>
  </div>
</template>

<script>
import { VProgressLinear } from 'vuetify/lib';

export default {
  name: "WorkProgressBar",
  props: {
    color: { type: String, default: 'var(--v-success-base)' },
    backgroundColor: { type: String, default: 'var(--v-border-lighten2)' },
    value: { type: Number },
    label: { type: String },
    indeterminate: { type: Boolean, default: false },
    showTooltip: { type: Boolean, default: false },
    progressBarHeight: { type: [Number, String], default: "0.75rem" },
    withPrepend: { type: Boolean, default: true },
    rounded: { type: Boolean, default: true },
    ...VProgressLinear.options.props
  },
};
</script>

<style lang="scss" scoped>
.progress-bar__label {
  @include w-p4
}

::v-deep .v-progress-linear {

  &.clickable-with-help {
    cursor: help;
  }

  &--rounded {
    border-radius: calc(#{$border-radius-root} * 2);
  }

  &__buffer {
    background-image: $progress-bar-bg-color;
    z-index: auto
  }

  &__determinate {
    /* border-top-right-radius: calc(#{$border-radius-root} * 2);
    border-bottom-right-radius: calc(#{$border-radius-root} * 2); */
    box-shadow: 0.125rem 0 0.125rem var(--v-background-darken3);
    background-image: $progress-bar-bg-color;
  }
}
</style>
